import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimContractGql } from '../BimContractRequests';

export const useBimContract = (contractId: number, withEffect = true) => {
    const getContractVariables = useMemo(
        () => ({
            contractId,
        }),
        [contractId],
    );

    const [getContractData, bimContractDataStatus, bimContractDataError, bimContractDataRequest] = useRequest({
        requestId: `bimContract${contractId}`,
        query: bimContractGql,
        withEffect: withEffect && Boolean(contractId),
        variables: getContractVariables,
    });

    const data = useMemo(() => getContractData?.bimContract?.data, [getContractData]);

    const [makeResetBimContract] = useResetStoreData({ requestId: `bimContract${contractId}` });

    return {
        bimContractData: data,
        bimContractDataStatus,
        bimContractDataError,
        bimContractDataRequest,
        makeResetBimContract,
    };
};
